import { Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "../../i18n/LanguageContext";

export default function Features() {
  
  const { t } = useTranslation();

  const [slideList] = useState([{
    img: 'feature-home',
    title: t('features.slide1.title'),
    alt: t('features.slide1.alt')
  }, {
    img: 'feature-insights',
    title: t('features.slide2.title'),
    alt: t('features.slide2.alt')
  }, {
    img: 'feature-archive',
    title: t('features.slide3.title'),
    alt: t('features.slide3.alt')
  }, {
    img: 'feature-share',
    title: t('features.slide4.title'),
    alt: t('features.slide4.alt')
  }])
  const [currentSlide, setCurrentSlide] = useState(slideList[0])

  return (
    <>
    <Flex
      as="section"
      aria-label={t("features.aria.section")}
      display={["none","inherit"]}
      backgroundColor={"background.grey"}
      px={"50px"}
      py={["30px","50px"]}
      borderRadius={"20px"}
      gap={"40px"}
      width={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
      border="1px solid"
      borderColor={"divider.grey"}
      flexDirection={"column"}
      overflow={"hidden"}
    >
      <Flex
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Text
          as="h2"
          fontSize={["25px", "30px"]}
          fontWeight={"500"}
          marginBottom={"30px"}
          alignItems={"center"}
          textAlign={"center"}
        >{currentSlide.title}
        </Text>
        <Flex
          maxW={"800px"}
          width={"100%"}
          transform={`translateX(-${(slideList.indexOf(currentSlide)) * 100}%)`}
          transition={"transform 0.3s ease-in-out"}
          role="tabpanel"
        >
          {slideList.map((slide, i) => (
            <Flex
              style={{
                perspective: "1000px"
              }}
              key={i}
              maxW={"800px"}
              width={"100%"}
              flexShrink={"0"}
              px={["2vw", "5vw"]}
            >
              <Flex
                maxW={"800px"}
                width={"100%"}
                borderRadius={"20px"}
                overflow={"hidden"}
                boxShadow={"0 4px 24px rgba(0,0,0,0.15)"}
                transform={`rotateY(${(i - slideList.indexOf(currentSlide)) * 20}deg) scaleY(${(1 - (Math.abs(i - slideList.indexOf(currentSlide)) * 0.2))})`}
                onClick={() => { setCurrentSlide(slide) }}
                transition={"transform 0.3s ease-in-out"}
                cursor={"pointer"}
              >
                <img
                  src={`/img/home/${slide.img}.webp`}
                  width={"100%"}
                  alt={slide.alt}
                  loading="lazy"
                />
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>
      <Flex gap={1} role="tablist" aria-label={t("features.aria.slides")}>
        {slideList.map((slide, i) => (
          <Flex
            key={i}
            w={"10px"}
            height={"10px"}
            backgroundColor={slideList.indexOf(currentSlide) === i ? "fill.coral" : 'background.coral'}
            border={"1px solid"}
            borderColor={"divider.coral"}
            cursor={'pointer'}
            borderRadius={"100%"}
            role="tab"
            aria-selected={slideList.indexOf(currentSlide) === i}
            aria-label={`${t("nav.features")} ${i + 1}: ${slide.title}`}
            onClick={() => {
              setCurrentSlide(slide)
            }} />
        ))}
      </Flex>
    </Flex>
    <Flex
      as="section"
      aria-label={t("features.aria.list")}
      flexDirection={"column"}
      borderTop={"1px solid"}
      borderColor={"divider.grey"}
      display={["inherit","none"]}
    >
      <Text
        as="h2"
        py={3}
        fontSize={"25px"}
        fontWeight={"500"}
      >{t("features.title")}</Text>
      <Flex
        flexDirection={"column"}
        gap={"20px"}
      >
        {slideList.map((slide, i) => (
          <Flex
            as="article"
            flexDirection={"column"}
            border="1px solid"
            borderColor={"divider.coral"}
            backgroundColor={"background.coral"}
            borderRadius={"10px"}
            overflow={"hidden"}
            key={i}
          >
            <Text
              as="h3"
              px={3}
              py={2}
              fontWeight={"500"}
              fontSize={"18px"}
            >{slide.title}</Text>
            <Flex
              borderTop="1px solid"
              borderColor={"divider.coral"}
            >
              <img
                src={`/img/home/${slide.img}-mobile.webp`}
                width={"100%"}
                alt={slide.alt}
                loading="lazy"
              />
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
    </>
  );
}
